import React from 'react';

function EmptyTemplate() {
  return (
    <div className="p-5 text-center text-gray-500">
      <p className="m-0 empty-text">
                Drag and drop files here to upload.
        <br />
                Or click <b>Choose</b> to select.
      </p>
    </div>
  );
}

export default EmptyTemplate;
